import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { connectResearchProperty } from 'bundles/project/actions/edge_crm';

import AssociationLink from 'bundles/crm/association_link';
import PropertyModal from 'bundles/crm/connect_property/modal';
import confirm from 'components/confirm';

export function CrmProperty({ connectResearchProperty, hasDeals, property }) {
  const [showModal, setShowModal] = useState(false);

  const handlePropertyChange = async (propertyId = null) => {
    const [verb, prep] = propertyId ? ['Connect', 'to'] : ['Disconnect', 'from'];
    if (hasDeals) {
      await confirm(
        `${verb}ing the property ${prep} this listing will also ${verb.toLowerCase()} the property ` +
          `${prep} the connected deals.`,
        {
          buttonLabel: verb,
          title: `${verb} Property ${prep} Listing Deals?`,
        }
      ).then(() => {
        connectResearchProperty(propertyId);
      });
    } else {
      connectResearchProperty(propertyId);
    }
  };

  return <>
    <AssociationLink
      record={property}
      recordTypeLabel="property"
      onAdd={() => setShowModal(true)}
      onRemove={() => handlePropertyChange(null)}
    />

    <PropertyModal
      show={showModal}
      onConnect={handlePropertyChange}
      onHide={() => setShowModal(false)}
    />
  </>;
}

CrmProperty.propTypes = {
  connectResearchProperty: PropTypes.func.isRequired,
  hasDeals: PropTypes.bool,
  property: PropTypes.shape({
    id: PropTypes.number.isRequired,
    address: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  hasDeals: state.deals?.length > 0,
  property: state.edgeCrm.researchProperty,
});

const mapDispatchToProps = {
  connectResearchProperty,
};

export default connect(mapStateToProps, mapDispatchToProps)(CrmProperty);

